import { type HTMLAttributes, Ref, useImperativeHandle, useRef } from 'react'
import { mergeRefs } from 'react-merge-refs'
import LivePhoto, { type LivePhotoHandle, type LivePhotoProps } from './LivePhoto'

interface BasicProps {
	isPreview?: boolean
	isLivePhoto?: boolean
	src?: string
}
export interface ImageProps extends HTMLAttributes<HTMLImageElement>, BasicProps {}
export interface LivePhotoPictureProps extends LivePhotoProps, BasicProps {}

export type PictureHandle = {
	livePhoto: LivePhotoHandle | null
	image: HTMLImageElement | null
}

export type PictureProps = (ImageProps | LivePhotoPictureProps) & {
	ref?: Ref<PictureHandle>
	imageRef?: Ref<HTMLImageElement>
}

export default function Picture({
	isLivePhoto = false,
	isPreview = false,
	ref,
	imageRef: imageRefProp,
	...props
}: PictureProps) {
	const livePhotoRef = useRef<LivePhotoHandle | null>(null)
	const imageRef = useRef<HTMLImageElement | null>(null)
	const mergedImageRef = mergeRefs([imageRef, imageRefProp])

	useImperativeHandle(ref, () => ({
		get livePhoto() {
			return livePhotoRef.current
		},
		get image() {
			return imageRef.current
		},
	}))

	if (isLivePhoto) {
		const { src, ...livePhotoProps } = props as LivePhotoPictureProps
		return (
			<LivePhoto
				{...(livePhotoProps as LivePhotoProps)}
				previewImageUrl={src}
				ref={livePhotoRef}
				isPreview={isPreview}
			/>
		)
	}

	return (
		<img
			referrerPolicy="no-referrer"
			loading="lazy"
			{...(props as ImageProps)}
			ref={mergedImageRef}
			alt="图片"
		/>
	)
}
